import { useDomainAccessControl } from 'domains/shifts/utils/domain/accessControl'
import { Flipper } from 'domains/shifts/access-control/flippers'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'
import { useValidWarehouseLocations } from 'domains/shifts/utils/hooks/useValidWarehouseLocations.hook'
import { PickingLabor } from 'legacy/common/types'

export const useIsRunnerDevicePrioritizationEnabled = ({
  warehouseLocationId,
}: {
  warehouseLocationId: string
}): boolean => {
  const warehouseContext = useWarehouseContext()
  const validLocations = useValidWarehouseLocations(warehouseContext)
  const selectedWarehouseLocation = validLocations.find(({ id }) => id === warehouseLocationId)

  const hasAccess = useDomainAccessControl()
  const hasFeatureFlagAccessUser = hasAccess([
    {
      flippers: [Flipper.RunnerDevicePrioritizationEnabled],
    },
  ])
  const hasFeatureFlagAccessWarehouse = hasAccess([
    {
      warehouseFlippers: [Flipper.RunnerDevicePrioritizationEnabled],
    },
  ])
  const hasFeatureFlagAccess = hasFeatureFlagAccessUser || hasFeatureFlagAccessWarehouse
  return hasFeatureFlagAccess && selectedWarehouseLocation.pickingLabor === PickingLabor.FullService
}
